module.exports = __webpack_public_path__ + "img/carousel-1.40c5cf38.jpg";